export class Counter {
  count = 0;
}
